(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["poe-switch-comparison"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('[data-up-compare]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const rows = Array.from(root.querySelectorAll('[data-compare-row]'));
      const filters = Array.from(root.querySelectorAll('[data-compare-filter]'));
      const count = root.querySelector('[data-compare-count]');
      const update = () => {
        let visible = 0;
        rows.forEach(row => {
          const match = filters.every(filter => !filter.value || row.dataset[filter.dataset.compareFilter] === filter.value);
          row.hidden = !match;
          if (match) visible++;
        });
        count.textContent = count.dataset.template.replace('__COUNT__', visible).replace('__TOTAL__', rows.length);
        root.querySelector('[data-compare-empty]').hidden = visible !== 0;
        root.querySelector('.up-compare__scroll').hidden = visible === 0;
      };
      filters.forEach(filter => filter.addEventListener('change', update));
      root.querySelector('[data-compare-reset]').addEventListener('click', () => { filters.forEach(filter => { filter.value = ''; }); update(); });
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) root.querySelectorAll('[data-compare-quote], [data-compare-product]').forEach(link => { const url = new URL(link.href); url.searchParams.set('preview_theme_id', preview); link.href = url.href; });
      root.querySelector('[data-compare-filters]').hidden = false;
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
